/**
 * A reply is awaited when the newest user message is newer than the newest assistant message.
 *
 * Every message counts, including an assistant reply whose userText is null. That reply renders
 * nothing, but it is what tells the client the tutor has finished — narrowing this list to the
 * messages that produce a visible turn would leave the typing indicator running forever.
 */
export function isAwaitingReply(kinds) {
    let lastUser = -1;
    let lastAssistant = -1;
    kinds.forEach((kind, index) => {
        if (kind === "user")
            lastUser = index;
        else if (kind === "assistant")
            lastAssistant = index;
    });
    return lastUser > lastAssistant;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXdhaXRpbmctcmVwbHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9jaGF0LXR1dG9yL2F3YWl0aW5nLXJlcGx5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7R0FNRztBQUNILE1BQU0sVUFBVSxlQUFlLENBQUMsS0FBZ0M7SUFDOUQsSUFBSSxRQUFRLEdBQUcsQ0FBQyxDQUFDLENBQUM7SUFDbEIsSUFBSSxhQUFhLEdBQUcsQ0FBQyxDQUFDLENBQUM7SUFDdkIsS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFDLElBQUksRUFBRSxLQUFLLEVBQUUsRUFBRTtRQUM1QixJQUFJLElBQUksS0FBSyxNQUFNO1lBQUUsUUFBUSxHQUFHLEtBQUssQ0FBQzthQUNqQyxJQUFJLElBQUksS0FBSyxXQUFXO1lBQUUsYUFBYSxHQUFHLEtBQUssQ0FBQztJQUN2RCxDQUFDLENBQUMsQ0FBQztJQUNILE9BQU8sUUFBUSxHQUFHLGFBQWEsQ0FBQztBQUNsQyxDQUFDIn0=